export default "/_next/static/images/modal3-fdcdd8d8aed6075434d3ee5ad1918eb8.png";